import { User } from '../models/user';

// Action Types Constants
export const USER_LOGGED_IN = 'USER_LOGGED_IN' as const;
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT' as const;
export const CHECK_NEW_MESSAGES = 'CHECK_NEW_MESSAGES' as const;

// Action Interfaces
export interface UserLoggedInAction {
  type: typeof USER_LOGGED_IN;
  payload: User;
  [key: string]: unknown;
}

export interface UserLoggedOutAction {
  type: typeof USER_LOGGED_OUT;
  [key: string]: unknown;
}

export interface CheckNewMessagesAction {
  type: typeof CHECK_NEW_MESSAGES;
  payload: boolean;
  [key: string]: unknown;
}

// Union Types
export type AuthActionTypes = UserLoggedInAction | UserLoggedOutAction;
export type MessagesActionTypes = CheckNewMessagesAction;
export type RootAction = AuthActionTypes | MessagesActionTypes;
